import { component } from 'picoapp'
import { createProductCard } from '@/lib/create-product-card'

export default component((node, ctx) => {
    const apiKey = theme.clerkApiKey
    const endpoint = node.dataset.endpoint
    const productId = node.dataset.productId
    const productType = node.dataset.productType
    const productVendor = node.dataset.productVendor
    let genderFilter = node.dataset.genderFilter
    const limit = parseInt(node.dataset.limit)
    const listEl = node.querySelector('.js-list')
    const newDifference = node.dataset.newDifference
    if (genderFilter.length == undefined || genderFilter == '') genderFilter = 'tags contains "gender_unisex"'
    const clerkFilter_gender_type_brand = genderFilter + ` and type = '${productType}' and vendor = '${productVendor}'`
    const clerkFilter_gender_type = genderFilter + ` and type = '${productType}'`
    const clerkFilter_gender = genderFilter

    getClerkRecommendations(clerkFilter_gender_type_brand).then((res) => {
        if (res.result.length > 5) {
            handleClerkData(res)
        } else {
            getClerkRecommendations(clerkFilter_gender_type).then((res) => {
                if (res.result.length > 5) {
                    handleClerkData(res)
                } else {
                    getClerkRecommendations(clerkFilter_gender).then((res) => {
                        handleClerkData(res)
                    })
                }
            })
        }
    })

    function getClerkRecommendations(filter) {
        return Clerk(
            'call',
            endpoint,
            {
                key: apiKey,
                products: [productId],
                limit: limit,
                labels: ['Product Page / ' + endpoint.split('/')[1]],
                attributes: ['handle'],
                filter: filter,
            },
            (response) => {
                return response
            },
            (response) => {
                console.error('error', response)
            }
        )
    }

    function handleClerkData(data) {
        if (data.result.length > 0) {
            let result = ''
            const allDone = []

            data.product_data.forEach((product) => {
                allDone.push(
                    fetch(`/products/${product.handle}.js`)
                        .then((response) => response.json())
                        .then((data) => {
                            result += createProductCard(data, newDifference, true)
                        })
                )
            })

            Promise.all(allDone).then(() => {
                listEl.innerHTML = result
                Clerk('click', '*[data-clerk-product-id]')
            })
        }
    }
})
